import api from './index'
import { axios } from '@/utils/request'

/**
 * login func
 * parameter: {
 *     username: '',
 *     password: '',
 *     remember_me: true,
 *     captcha: '12345'
 * }
 * @param parameter
 * @returns {*}
 */
// export function login (parameter) {
//   // return axios({
//   //   url: '/auth/login',
//   //   method: 'post',
//   //   data: parameter
//   // })
//   return new Promise((resolve) => {
//     resolve({
//       'message': '',
//       'status': 200,
//       'timestamp': 1534844188679,
//       'body': {
//         'password': '21232f297a57a5a743894a0e4a801fc3',
//         'username': 'admin'
//       },
//       'result': {
//         'id': '4291d7da9005377ec9aec4a71ea837f',
//         'name': 'Barbara Jones',
//         'username': 'admin',
//         'password': '',
//         'avatar': 'https://gw.alipayobjects.com/zos/rmsportal/jZUIxmJycoymBprLOUbT.png',
//         'status': 1,
//         'telephone': '',
//         'lastLoginIp': '127.0.0.1',
//         'lastLoginTime': 1534837621348,
//         'creatorId': 'admin',
//         'createTime': 1497160610259,
//         'deleted': 0,
//         'roleId': 'admin',
//         'token': '4291d7da9005377ec9aec4a71ea837f'
//       }
//     })
//   })
// }

export function login (parameter) {
  return new Promise((resolve, reject) => {
    axios({
      url: '/auth/login',
      method: 'post',
      data: parameter
    }).then(response => {
      resolve(response)
    }).catch(error => {
      reject(error)
    })
  })
}

export function getSmsCaptcha (parameter) {
  return axios({
    url: api.SendSms,
    method: 'post',
    data: parameter
  })
}

export function getInfo () {
  return axios({
    url: '/user/info',
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function logout () {
  return axios({
    url: '/auth/logout',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 使用 admin portal token进行登录
export function portalTokenLogin (adminPortalToken) {
  return axios({
    url: '/auth/loginByAdminPortal',
    method: 'post',
    params: { adminPortalToken: adminPortalToken }
  })
}
